import { useMemo } from 'react';

export const useGetPageOptions = () => {
  const pageOptions = useMemo(
    () =>
      [5, 10, 25, 50, 75, 100].map((value) => ({
        value,
        label: `${value}`,
      })),
    []
  );

  return { data: { pageOptions } };
};
